import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column ga-4" }
const _hoisted_2 = { class: "text-body-1" }
const _hoisted_3 = { class: "d-flex ga-2 flex-wrap justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _ctx.showConsent,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showConsent) = $event)),
    timeout: -1,
    location: "bottom",
    "multi-line": "",
    color: "surface"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _cache[2] || (_cache[2] = _createTextVNode(" We use cookies to improve your experience and analyze site usage. ")),
          _createVNode(_component_router_link, {
            to: "/privacy",
            target: "_blank"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Learn more")
            ])),
            _: 1,
            __: [1]
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_btn, {
            variant: "outlined",
            size: "small",
            onClick: _ctx.declineAnalytics
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Decline ")
            ])),
            _: 1,
            __: [3]
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            color: "primary",
            size: "small",
            onClick: _ctx.acceptAnalytics
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Accept Analytics ")
            ])),
            _: 1,
            __: [4]
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}